
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire06c0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire06c0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gl7JN", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $be549c0715229b5f$export$6503ec6e8aabbaf; }, function (v) { return $be549c0715229b5f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $be549c0715229b5f$export$f7ad0328861e2f03; }, function (v) { return $be549c0715229b5f$export$f7ad0328861e2f03 = v; });
var $be549c0715229b5f$export$6503ec6e8aabbaf;
var $be549c0715229b5f$export$f7ad0328861e2f03;
"use strict";
var $be549c0715229b5f$var$mapping = new Map();
function $be549c0715229b5f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$be549c0715229b5f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $be549c0715229b5f$var$resolve(id) {
    var resolved = $be549c0715229b5f$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$be549c0715229b5f$export$6503ec6e8aabbaf = $be549c0715229b5f$var$register;
$be549c0715229b5f$export$f7ad0328861e2f03 = $be549c0715229b5f$var$resolve;

});

var $ce9d416ca8931264$exports = {};

(parcelRequire("gl7JN")).register(new URL("", import.meta.url).toString(), JSON.parse('["1kikK","index.28304131.js","2PbNc","Grocery.174158ee.js"]'));


//# sourceMappingURL=index.runtime.9f616576.js.map
